import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import * as History from 'history'
import rootReducer from '../reducers'

export const history = History.createBrowserHistory()

const middlewares = [thunk]

const store = createStore(
  rootReducer,
  compose(
    applyMiddleware(...middlewares),
  )
)

export default store
